import type { ObjectType } from '@/store/editor';

export type Tool = { icon: string; label: string; active?: boolean };
export type ToolGroup = Tool | { sep: true };

export const toolSets: Record<ObjectType, ToolGroup[]> = {
  default: [
    { icon: 'mouse-pointer-2', label: 'Markor', active: true },
    { icon: 'hand', label: 'Panorera' },
    { icon: 'zoom-in', label: 'Zooma' },
    { sep: true },
    { icon: 'scissors', label: 'Klipp scen' },
    { icon: 'wand-2', label: 'Magic Brush' },
    { icon: 'type', label: 'Text' },
  ],
  sky: [
    { icon: 'cloud', label: 'Byt himmel', active: true },
    { icon: 'sun', label: 'Ljussatt' },
    { icon: 'cloud-drizzle', label: 'Lagg till moln' },
    { icon: 'moon', label: 'Tid pa dygnet' },
    { sep: true },
    { icon: 'wand-2', label: 'Magic Brush' },
  ],
  sun: [
    { icon: 'sun', label: 'Solljus', active: true },
    { icon: 'palette', label: 'Farga sol' },
    { icon: 'move', label: 'Flytta sol' },
    { icon: 'zap', label: 'Lens flare' },
    { sep: true },
    { icon: 'wand-2', label: 'Magic Brush' },
  ],
  mountain: [
    { icon: 'mountain-snow', label: 'Ersatt landskap', active: true },
    { icon: 'layers', label: 'Djup' },
    { icon: 'cloud-fog', label: 'Dimma' },
    { sep: true },
    { icon: 'wand-2', label: 'Magic Brush' },
  ],
  person: [
    { icon: 'user-round', label: 'Persondetaljer', active: true },
    { icon: 'shirt', label: 'Byt klader' },
    { icon: 'sparkles', label: 'Stilisera' },
    { icon: 'move', label: 'Flytta person' },
    { icon: 'user-check', label: 'Byt person' },
    { sep: true },
    { icon: 'wand-2', label: 'Magic Brush' },
  ],
  face: [
    { icon: 'sun', label: 'Ljussatt ansikte', active: true },
    { icon: 'sparkles', label: 'Slata hud' },
    { icon: 'smile', label: 'Uttryck' },
    { icon: 'scan-face', label: 'Detaljer' },
    { icon: 'user-check', label: 'Byt person' },
    { icon: 'move-3d', label: 'Animera' },
    { sep: true },
    { icon: 'wand-2', label: 'Magic Brush' },
  ],
  title: [
    { icon: 'type', label: 'Redigera text', active: true },
    { icon: 'palette', label: 'Farg' },
    { icon: 'bold', label: 'Typsnitt' },
    { icon: 'move', label: 'Position' },
    { icon: 'zap', label: 'Animation' },
    { sep: true },
    { icon: 'wand-2', label: 'Magic Brush' },
  ],
};
